/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Carrier_Shipment_Not_FoundInputs */

const vi_error_carrier_shipment_not_found = /** @type {(inputs: Error_Carrier_Shipment_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn này chưa có vận đơn của đơn vị vận chuyển.`)
};

/**

* @param {Error_Carrier_Shipment_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_carrier_shipment_not_found = /** @type {((inputs?: Error_Carrier_Shipment_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Carrier_Shipment_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_carrier_shipment_not_found(inputs)
});